import { useState, useEffect } from "react";
import useRole from "./useRole";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/slicers/authInfo";

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        let token = localStorage.getItem("usersdatatoken");
        const res = await fetch(
          `${process.env.REACT_APP_BACK_URL}/api/user/validuser`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: token,
            },
          },
        );

        const data = await res.json();
        console.log(data);

        if (res.status === 401 || !data) {
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
          dispatch(setUser(data?.ValidUserOne));
        }
      } catch (error) {
        console.error("Error checking authentication", error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  return { isAuthenticated, loading };
};
